import { default as Modal } from './CustomModal';

export default Modal;